/**
 * Box Shadow Colors that is matched with the ones used in Fabric. We are making a copy of it here
 * to prevent fabric changes from breaking us.
 */

export const depths = {
  depth0: "0 0 0 0 transparent",
  depth4:
    "0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)",
  depth8:
    "0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)",
  depth16:
    "0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)",
  depth64:
    "0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)",
};

export const fluentUIDepths = {
  depth0: "0 0 0 0 transparent",
  depth2: "0 1px 2px rgba(0, 0, 0, 0.14), 0 0 2px rgba(0, 0, 0, 0.12)",
  depth4: "0 2px 4px rgba(0, 0, 0, 0.14), 0 0 2px rgba(0, 0, 0, 0.12)",
  depth8: "0 4px 8px rgba(0, 0, 0, 0.14), 0 0 2px rgba(0, 0, 0, 0.12)",
  depth16: "0 8px 16px rgba(0, 0, 0, 0.14), 0 0 2px rgba(0, 0, 0, 0.12)",
  depth28: "0 14px 28.8px rgba(0, 0, 0, 0.24), 0 0 8px rgba(0, 0, 0, 0.2)",
  depth64: "0 32px 64px rgba(0, 0, 0, 0.24), 0 0 8px rgba(0, 0, 0, 0.2)",
};
